import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=05941378&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=05941378&prod&scoped=true&lang=scss&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=05941378&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05941378",
  null
  
)

export default component.exports